import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import backgroundImage from "../assets/img/landing.png";
import { Link } from 'react-router-dom'
import { Links } from "../util/util";

const theme = createTheme({
    typography: {
        useNextVariants: true,
    },
    overrides: {
        MuiPaper: {
            root: {
                padding: '10px',
                marginBottom: '10px',
                backgroundColor: "var(--primary)"
            },
        },
    }
});

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class Menu extends Component {
    render() {
        const contactAnchorStyle = {
            color: 'white',
            fontSize: 36,
            fontWeight: '600'
        };
        return (
            <ThemeProvider theme={theme}>
                <Dialog
                    fullScreen
                    open={this.props.open}
                    onClose={this.props.handleClose}
                    TransitionComponent={Transition}>
                    <div className={'container-fluid'} style={{
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        height: '100vh'
                    }}>
                        <div style={{
                            marginTop: 15,
                            marginRight: 30,
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}>
                            <IconButton style={{
                                color: "var(--primary)",
                                boxShadow: "0 2px 3px 2px rgba(0,0,0,0.16)",
                                backgroundColor: 'white',
                                height: 60,
                                width: 60,
                                animationName: 'App-logo-spin',
                            }} onClick={this.props.handleClose} aria-label="Close">
                                <CloseIcon />
                            </IconButton>
                        </div>
                        <div className={'row'} style={{ marginTop: 32 }}>
                            <div className={'col-10 offset-1 col-md-8 offset-md-2'}>
                                <div style={{ color: 'white' }}>Menu</div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <hr style={{
                                        marginLeft: 0,
                                        width: 163,
                                        borderTop: '1px solid white'
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className='column'>
                            <div className='col-md-3 offset-md-2 col-10 offset-1'
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    fontSize: 50,
                                    fontWeight: 600,
                                    color: 'white',
                                    flexDirection: 'column',
                                    lineHeight: '90px'
                                }}>
                                <Link to={Links.HOME} className={'menu-text'}
                                    onClick={this.props.handleClose}>Home</Link>
                                <Link to={Links.WORK} className={'menu-text'}
                                    onClick={this.props.handleClose}>Work</Link>
                                <Link to={Links.ABOUT} className={'menu-text'}
                                    onClick={this.props.handleClose}>About</Link>
                                <Link to={Links.CONTACT} className={'menu-text'}
                                    onClick={this.props.handleClose}>Contact</Link>

                            </div>
                            <div className='col-md-3 offset-md-2 col-10 offset-1' style={{
                                marginTop: '60px',
                                display: 'flex',
                                alignItems: 'flex-start',
                                color: 'white',
                                flexDirection: 'column',
                                fontWeight: 400
                            }}>
                                <div>
                                    <a href={Links.EMAIL_LINK}
                                        style={contactAnchorStyle}>{Links.EMAIL}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </ThemeProvider>
        )
    }
};
export default Menu;
